<ng-container *ngIf="ready">
  <div class="center-content list-spacing">
    <se-fe-icon seFeDataName="spot_id_card" seFeDataSize="950" [seFeDataMargin]="false"></se-fe-icon>
      <se-po-highlight-label
        theme="child"
        [label]="'SE_PO_SHARED_FEATURE_HOUSEHOLD_REVIEW.TITLE' | translate"
        class="list-spacing">
      </se-po-highlight-label>
    <div>{{ 'SE_PO_SHARED_FEATURE_HOUSEHOLD_REVIEW.SUBTITLE' | translate }}</div>
  </div>
  <div class="info-card">
    <se-fe-header [seFeDataTitle]="'SE_PO_SHARED_FEATURE_HOUSEHOLD_REVIEW.CHILD_INFO' | translate" class="list-spacing"></se-fe-header>
    <div class="list-spacing">
      <se-fe-card>
        <se-fe-card-content>
          <se-po-persona-avatar
            [persona]="child">
          </se-po-persona-avatar>
        </se-fe-card-content>
      </se-fe-card>
    </div>
      <se-fe-header [seFeDataTitle]="'SE_PO_SHARED_FEATURE_HOUSEHOLD_REVIEW.PARENT_INFO' | translate" class="list-spacing"></se-fe-header>
      <div class="list-spacing">
          <se-po-parent-contact-info
              [persona]="parent">
          </se-po-parent-contact-info>
      </div>
      <div *ngFor="let invite of guardianInvites">
        <div class="list-spacing">
          <se-po-guardian-invite-info
            class="list-spacing"
            [guardianToInvite]="invite"
            (cancelInvite)="onCancelInvite($event)">
          </se-po-guardian-invite-info>
        </div>
      </div>
    <se-fe-button seFeDataEmphasis="high" [seFeDataFullWidth]="true" (click)="onContinue()">{{ 'SE_PO_SHARED_FEATURE_HOUSEHOLD_REVIEW.SUBMIT' | translate }}</se-fe-button>
    <se-fe-button seFeDataEmphasis="low" [seFeDataFullWidth]="true" (click)="onAddAnother()" style="margin-top: 8px;">
      {{ 'SE_PO_SHARED_FEATURE_HOUSEHOLD_REVIEW.' + (guardianInvites.length ? 'SEND_ANOTHER' : 'SEND_FIRST') | translate }}
    </se-fe-button>
  </div>
</ng-container>
<se-fe-toast></se-fe-toast>
